import { apiClient } from '@/config/api';
import { HydraCollection } from '@/types';

export interface ProjectAttributeType {
  id: number;
  project: {
    id: number;
    title: string;
  };
  attributeType: {
    id: number;
    code: string;
    name: string;
  };
  loadData: boolean;
}

export const projectAttributeTypeService = {
  // Get all project attribute types for a project
  async getByProject(projectId: number): Promise<ProjectAttributeType[]> {
    const response = await apiClient.get<HydraCollection<ProjectAttributeType>>('/project_attribute_types', {
      params: {
        'project': `/api/projects/${projectId}`,
        pagination: false,
        'groups[]': ['projectAttributeType:read'],
      },
    });

    const data = response.data;
    if (Array.isArray(data)) {
      return data;
    }
    return data['hydra:member'] || data['member'] || [];
  },

  // Update project attribute type loadData field
  async updateLoadData(projectId: number, attributeTypeId: number, loadData: boolean): Promise<ProjectAttributeType> {
    const response = await apiClient.put(
      `/projects/${projectId}/attribute-types/${attributeTypeId}/load-data`,
      { loadData }
    );
    return response.data;
  },
};
